import React from 'react';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { connect } from 'react-redux';

import {
    makeSelectValuesTimesheetEntryValue
    // @ts-ignore
} from 'services/timesheetTimesheetEntriesForm/selectors';
// @ts-ignore
import PersonFullName from 'components/PersonFullName';
// @ts-ignore
import FormTimesheetEntryValue from '../FormTimesheetEntryValue';

interface OwnProps {
    rowId: number;
}

interface ConnectedProps {
    isApproved: boolean;
}

type Props = OwnProps & ConnectedProps;

export class PersonFullNameFieldValueComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { rowId, isApproved } = this.props;

        if (isApproved) {
            return (
                <FormTimesheetEntryValue
                    rowId={rowId}
                    cellName="personFullName"
                />
            );
        }

        return (
            <FormTimesheetEntryValue rowId={rowId} cellName="personId">
                {(personId: number): React.ReactElement => (
                    <PersonFullName personId={personId} />
                )}
            </FormTimesheetEntryValue>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isApproved: makeSelectValuesTimesheetEntryValue('lastReviewIsApproved')
});

export default connect(mapStateToProps)(PersonFullNameFieldValueComponent);
